<template>
  <div id="websitelanding">
    <section id="hero">
      <div class="white--text mx-auto d-flex flex-wrap justify-center">
        <div class="hero-header">
          <div class="hero-brand">
            <img
              class="hero-logo"
              src="@/assets/logo-v2-long_no-space.svg"
              alt="Juffrou Anri"
            />
            <span class="hero-slogan font-weight-light black--text">
              FOR SOUTH AFRICAN TEACHERS AND PARENTS - WE’VE DONE THE HARD WORK
              FOR YOU.
            </span>
          </div>
          <img
            class="hero-mascot"
            src="@/assets/juffrou-anri-animate.gif"
            alt=""
          />
        </div>

        <v-col
          cols="12"
          class="channel-picker d-flex flex-wrap align-center justify-center py-1 black--text"
        >
          <span
            class="text-h4 font-weight-bold primary--text text-uppercase mr-2"
            >I am a:</span
          >
          <v-chip-group v-model="channel" column active-class="primary--text">
            <v-chip
              v-for="option in channelOptions"
              :key="option"
              :value="option"
              filter
              outlined
            >
              {{ option }}
            </v-chip>
          </v-chip-group>
        </v-col>

        <v-col
          cols="12"
          tag="h1"
          class="d-flex flex-column flex-wrap"
          :class="commHeadings?.length > 0 ? 'py-0' : ''"
          style="align-items: center"
        >
          <CommunicationCard
            v-for="comm in commHeadings"
            :key="comm.id"
            :body="comm.body"
            :subject="comm.subject"
            :videoSrc="comm.video"
            :images="comm.images"
            :show="comm.show"
            :countDownTo="comm.countDownTo"
            :listItems="comm.listItems"
            :outlined="false"
            :max-width="$vuetify.breakpoint.mdAndUp ? '500px' : null"
          ></CommunicationCard>
        </v-col>
      </div>
    </section>

    <section id="featured-resources">
      <!-- <v-row no-gutters> -->
      <!-- <v-col cols="12"> -->
      <v-container class="text-center">
        <ProductsGrid
          :search="true"
          :featured="false"
          :productLimit="4"
          @openCloseCartDialog="openCloseCartDialog"
        />
      </v-container>
      <!-- </v-col> -->
      <!-- <v-col cols="12" md="1" class="pb-0">
          <v-img
            align-start
            max-height="270"
            src="@/assets/juffrou-anri-animate.gif"
            contain
          ></v-img>
        </v-col> -->
      <!-- </v-row> -->
    </section>

    <section id="features-and-video">
      <div class="d-flex" style="flex-flow: wrap-reverse">
        <v-col :cols="screenWidth > 1500 ? '12' : '12'" style="padding: 0 8px">
          <v-container class="text-center">
            <!-- <h2 class="display-2 font-weight-bold mb-3">FEATURES</h2>

            <v-responsive class="mx-auto mb-12" width="56">
              <v-divider></v-divider>

              <v-divider></v-divider>
            </v-responsive> -->

            <v-row>
              <v-col
                v-for="({ icon, title, text }, i) in features"
                :key="i"
                cols="12"
                md="4"
              >
                <v-card
                  class="py-12 px-4 elevation-12"
                  color="grey lighten-5"
                  flat
                  height="100%"
                >
                  <v-theme-provider dark>
                    <div class="mb-6">
                      <v-avatar color="primary" size="88">
                        <v-icon large>{{ icon }}</v-icon>
                      </v-avatar>
                    </div>
                  </v-theme-provider>

                  <v-card-title
                    class="justify-center text-uppercase"
                    v-html="title"
                    style="font-size: 28px"
                  >
                  </v-card-title>
                  <div>
                    {{ text }}
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-col>

        <!-- <v-col :cols="screenWidth > 1500 ? '6' : '12'" style="padding: 0px">
          <v-container class="pa-0 text-center">
            <v-row no-gutters>
              <v-col>
                <div
                  id="video-embed"
                  :class="
                    screenWidth > 1750
                      ? 'iframe-padding-huge'
                      : screenWidth > 1618
                      ? 'iframe-padding-small'
                      : screenWidth < 700
                      ? 'iframe-padding-mobile'
                      : screenWidth < 1619
                      ? 'iframe-padding-small'
                      : 'iframe-padding-large'
                  "
                >
                  <div>
                    <iframe
                      width="1280"
                      height="720"
                      src="//www.youtube.com/embed/c_GorHGJ9Qg?rel=0&loop=1&autoplay=1"
                      frameborder="0"
                    ></iframe>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-col> -->
      </div>
      <div class="py-8"></div>
    </section>

    <!-- <section id="hero">
      <v-row no-gutters>
        <v-img :min-height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
          :max-height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
          src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1951&q=99">
          <v-theme-provider dark>
            <v-container fill-height fluid ma-0 pa-0>
              <v-row align-items="center" class="white--text mx-auto" justify="center">
                <v-col class="white--text text-center" cols="12" tag="h1">
                  <span :class="[
                    $vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2',
                  ]" class="font-weight-light">
                    WELCOME TO
                  </span>

                  <br />

                  <span :class="[
                    $vuetify.breakpoint.smAndDown ? 'display-3' : 'display-4',
                  ]" class="font-weight-bold primary--text">JUFFROU ANRI<br />SE KLASKAMER</span>
                </v-col>

                <v-btn class="align-self-end" fab outlined @click="$vuetify.goTo('#about-me')">
                  <v-icon>mdi-chevron-double-down</v-icon>
                </v-btn>
              </v-row>
            </v-container>
          </v-theme-provider>
        </v-img>
      </v-row>
    </section> -->

    <!-- //HIDE-subscription-17Dec2024 <section id="subscribe-section" style="background-color: #ffa9b8">
      <div class="py-8"></div>
      <v-container class="text-center">
        <v-btn
          id="subscribe-btn"
          width="300"
          height="70"
          color="white"
          class="text-h4"
          to="/app/profile"
          >Subscribe Now!</v-btn
        >
      </v-container>
      <div class="py-8"></div>
    </section> -->

    <section id="about-me">
      <div class="py-8"></div>

      <v-container class="text-center">
        <h2 class="display-2 font-weight-bold mb-3">
          Experience the Future of Education
        </h2>

        <v-responsive class="mx-auto mb-8" width="56">
          <v-divider></v-divider>

          <v-divider></v-divider>
        </v-responsive>

        <v-responsive class="mx-auto font-weight-light mb-8" max-width="720">
          Welcome to Juffrou Anri, where innovation meets education. We are a
          passionate team of educators dedicated to revolutionising teaching and
          learning. Our mission is to empower educators across South Africa with
          the tools and resources they need to create engaging, effective, and
          personalised learning experiences.
        </v-responsive>

        <v-avatar class="pa-3 elevation-12 mb-12" size="158">
          <v-img contain :src="require('@/assets/logo-v2-square.svg')"></v-img>
        </v-avatar>
        <div></div>

        <v-btn color="grey" to="/about" outlined large>
          <span class="grey--text text--darken-1 font-weight-bold">
            Read more
          </span>
        </v-btn>

        <v-row class="mt-12">
          <v-col
            v-for="({ icon, title, text }, i) in planning"
            :key="i"
            cols="12"
            md="4"
          >
            <v-card
              class="py-12 px-4 elevation-12"
              color="grey lighten-5"
              flat
              height="100%"
            >
              <v-theme-provider dark>
                <div class="mb-6">
                  <v-avatar color="primary" size="88">
                    <v-icon large>{{ icon }}</v-icon>
                  </v-avatar>
                </div>
              </v-theme-provider>

              <v-card-title
                class="justify-center text-uppercase"
                v-html="title"
                style="font-size: 28px"
              >
              </v-card-title>
              <div>
                {{ text }}
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <div class="py-12"></div>
    </section>

    <!-- <section id="featured-resources">
      <div class="py-8"></div>

      <v-container class="text-center">
        <h2 class="display-2 font-weight-bold mb-3">Featured Resources</h2>

        <v-responsive class="mx-auto mb-8" width="56">
          <v-divider></v-divider>

          <v-divider></v-divider>
        </v-responsive>

        <ProductsGrid :search="false" :featured="true" />
      </v-container>

      <div class="py-12"></div>
    </section> -->

    <section id="stats">
      <div
        style="
          background-attachment: fixed;
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
          color: #ffffff;
        "
        class="parallax"
      >
        <v-container fill-height style="padding: 120px 0">
          <v-row class="mx-auto">
            <v-col
              v-for="[value, title] of stats"
              :key="title"
              cols="12"
              md="4"
            >
              <div class="text-center">
                <div
                  class="display-3 font-weight-bold mb-4"
                  v-text="value"
                ></div>

                <div
                  class="title font-weight-regular text-uppercase"
                  v-text="title"
                ></div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </section>

    <!-- <section id="blog">
      <div class="py-12"></div>

      <v-container>
        <h2 class="display-2 font-weight-bold mb-3 text-uppercase text-center">
          Blog
        </h2>

        <v-responsive class="mx-auto mb-12" width="56">
          <v-divider class="mb-1"></v-divider>

          <v-divider></v-divider>
        </v-responsive>

        <v-row>
          <v-col
            v-for="({ src, text, title }, i) in articles"
            :key="i"
            cols="12"
            md="4"
          >
            <v-img
              :src="src"
              class="mb-4"
              height="275"
              max-width="100%"
            ></v-img>

            <h3
              class="font-weight-black mb-4 text-uppercase"
              v-text="title"
            ></h3>

            <div class="title font-weight-light mb-5" v-text="text"></div>

            <v-btn class="ml-n4 font-weight-black" text>
              Continue Reading
            </v-btn>
          </v-col>
        </v-row>
      </v-container>

      <div class="py-12"></div>
    </section> -->

    <ContactForm />
  </div>
</template>

<script>
import ContactForm from "@/components/global-components/ContactForm.vue";
import ProductsGrid from "@/components/global-components/ProductsGrid.vue";
import { API } from "aws-amplify";
import { communicationsByAppArea } from "@/graphql/queries";
import { mapState } from "vuex";
import CommunicationCard from "@/components/global-components/CommunicationCard.vue";
import {
  onCreateCommunicationAppArea,
  onUpdateCommunicationAppArea,
  onDeleteCommunicationAppArea,
} from "@/graphql/subscriptions";

export default {
  name: "WebsiteLandingView",

  components: { ContactForm, ProductsGrid, CommunicationCard },

  data() {
    return {
      queriedCommunications: [],

      // Audience/channel picker ("I am a ...")
      channelOptions: ["Teacher", "Parent", "School Management"],
      channel: null,

      articles: [
        {
          src: "https://images.unsplash.com/photo-1423784346385-c1d4dac9893a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80",
          title: "Mobile first & Responsive",
          text: "Phasellus lorem enim, luctus ut velit eget, convallis egestas eros. Sed ornare ligula eget tortor tempor, quis porta tellus dictum.",
        },
        {
          src: "https://images.unsplash.com/photo-1475938476802-32a7e851dad1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80",
          title: "Think outside the box",
          text: "Nam ut leo ipsum. Maecenas pretium aliquam feugiat. Aenean vel tempor est, vitae tincidunt risus. Sed sodales vestibulum nibh.",
        },
        {
          src: "https://images.unsplash.com/photo-1416339442236-8ceb164046f8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1892&q=80",
          title: "Small changes, big difference",
          text: "Vestibulum in dictum velit, in rhoncus nibh. Maecenas neque libero, interdum a dignissim in, aliquet vitae lectus. Phasellus lorem enim, luctus ut velit eget.",
        },
      ],
      features: [
        {
          icon: "mdi-book-plus-multiple",
          title: "BUY INDIVIDUAL<br>PRODUCTS OR<br>BUNDLES",
        },
        // {
        //   icon: "mdi-forum-outline",
        //   title: "AFRIKAANS<br>ENGLISH",
        // },
        {
          icon: "mdi-file-pdf-box",
          title: "WORKSHEETS<br>ASSESSMENTS<br>PLANNING<br>DECOR",
        },
        {
          icon: "mdi-folder-outline",
          title: "CAPS<br>ATP",
        },
      ],
      planning: [
        {
          icon: "mdi-calendar-month-outline",
          title: "Monthly and bi-weekly planning",
          text: "Plan your teaching schedule with our user-friendly Calendar feature. Seamlessly navigate bi-weekly schedules, ensuring optimal time allocation for lesson planning, assessments, and student engagement.",
        },
        {
          icon: "mdi-tools",
          title: "Planning tool",
          text: "Streamline the assessment and lesson planning process with our planning tool. Set question weightings and define cognitive levels. Seamlessly align your lesson plans and assessments with the South African curriculum, ensuring you cover all the necessary topics and learning outcomes.",
        },
        {
          icon: "mdi-face-agent",
          title: "Teaching support",
          text: "Experience support with our Teacher Support feature. Connect with experienced educators who are ready to answer your questions, provide guidance, and share best practices for effective teaching.",
        },
      ],
      stats: [
        ["35K+", "Customers"],
        ["158K+", "Resources sold"],
        ["86K+", "Social Media followers"],
      ],
    };
  },

  computed: {
    ...mapState({
      userSignedIn: (state) => state.userSignedIn,
    }),
    // Computed property for the screen width
    screenWidth() {
      let width = this.$vuetify.breakpoint.width;
      return width;
    },

    commHeadings() {
      // Normalise sendTo to an array (tolerate a single string)
      const normaliseSendTo = (c) =>
        Array.isArray(c.sendTo) ? c.sendTo : c.sendTo ? [c.sendTo] : [];

      // Targeted at a specific audience (Teacher / Parent / School Management)?
      const isChannelSpecific = (c) =>
        normaliseSendTo(c).some((s) => this.channelOptions.includes(s));

      return this.queriedCommunications
        .filter((c) => {
          if (c.appArea !== "Landing-Header" || c._deleted) return false;

          const sendTo = normaliseSendTo(c);

          // "ALL" communications are always shown
          if (sendTo.includes("ALL")) return true;

          // Keep if the selected channel is one of the comm's targets
          return sendTo.includes(this.channel);
        })
        .sort(
          // Channel-specific comms first, "ALL"-only comms last
          (a, b) => Number(isChannelSpecific(b)) - Number(isChannelSpecific(a)),
        );
    },

    authMode() {
      return this.userSignedIn ? "AMAZON_COGNITO_USER_POOLS" : "AWS_IAM";
    },
  },

  created() {
    // Restore the user's saved audience choice
    const saved = localStorage.getItem("channel");
    if (this.channelOptions.includes(saved)) {
      this.channel = saved;
    }
  },

  watch: {
    channel(newVal) {
      if (newVal) {
        localStorage.setItem("channel", newVal);
      } else {
        localStorage.removeItem("channel");
      }
    },
  },

  async beforeMount() {
    try {
      this.subscribeToCommunicationCreate();
      this.subscribeToCommunicationUpdate();
      this.subscribeToCommunicationDelete();

      const now = new Date().toISOString();
      const response = await API.graphql({
        query: communicationsByAppArea,
        variables: {
          filter: {
            and: [
              { _deleted: { ne: true } },
              { publishDate: { attributeExists: true } },
              { publishDate: { lt: now } },
            ],
          },
          appArea: "Landing-Header",
        },
        authMode: this.authMode,
      });

      if (response?.data?.communicationsByAppArea?.items) {
        this.queriedCommunications.push(
          ...response.data.communicationsByAppArea.items,
        );
        // console.log("this.queriedCommunications", this.queriedCommunications);
      }
      // Handle response data as needed
    } catch (error) {
      console.error("Error fetching communications:", error);
    }
  },

  methods: {
    openCloseCartDialog() {
      this.$emit("openCloseCartDialog");
    },

    subscribeToCommunicationCreate() {
      console.log("this.authMode", this.authMode);
      API.graphql({
        query: onCreateCommunicationAppArea,
        variables: { appArea: "Landing-Header" },
        authMode: this.authMode,
      }).subscribe({
        next: ({ value }) => {
          const newComm = value.data.onCreateCommunicationAppArea;
          const now = new Date().toISOString();
          if (
            !newComm._deleted &&
            newComm.publishDate &&
            newComm.publishDate <= now
          ) {
            this.queriedCommunications.push(newComm);
          }
        },
        error: (error) => console.error("Subscription error (create):", error),
      });
    },

    subscribeToCommunicationUpdate() {
      API.graphql({
        query: onUpdateCommunicationAppArea,
        variables: { appArea: "Landing-Header" },
        authMode: this.authMode,
      }).subscribe({
        next: ({ value }) => {
          const updatedComm = value.data.onUpdateCommunicationAppArea;
          console.log("updatedComm", updatedComm);
          const now = new Date().toISOString();
          const index = this.queriedCommunications.findIndex(
            (c) => c.id === updatedComm.id,
          );
          if (
            !updatedComm._deleted &&
            updatedComm.publishDate &&
            updatedComm.publishDate <= now
          ) {
            if (index !== -1) {
              this.$set(this.queriedCommunications, index, updatedComm);
            } else {
              this.queriedCommunications.push(updatedComm);
            }
          } else {
            if (index !== -1) {
              this.queriedCommunications.splice(index, 1);
            }
          }
        },
        error: (error) => console.error("Subscription error (update):", error),
      });
    },

    subscribeToCommunicationDelete() {
      API.graphql({
        query: onDeleteCommunicationAppArea,
        variables: { appArea: "Landing-Header" },
        authMode: this.authMode,
      }).subscribe({
        next: ({ value }) => {
          const deletedComm = value.data.onDeleteCommunicationAppArea;
          const index = this.queriedCommunications.findIndex(
            (c) => c.id === deletedComm.id,
          );
          if (index !== -1) {
            this.queriedCommunications.splice(index, 1);
          }
        },
        error: (error) => console.error("Subscription error (delete):", error),
      });
    },
  },
};
</script>

<style>
/* ─────────────────────────────────────────────
   Hero header (logo + slogan + mascot gif)
   The only two knobs you need to touch:
   --hero-height       → overall block height
   --hero-padding-top  → space above the block
   ───────────────────────────────────────────── */
#hero .hero-header {
  --hero-height: clamp(70px, 13vw, 150px);
  --hero-padding-top: clamp(20px, 3vw, 40px);

  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(8px, 2vw, 24px);
  padding-top: var(--hero-padding-top);
  padding-inline: clamp(12px, 4vw, 32px); /* side breathing room on mobile */
  max-width: 100%;
}

#hero .hero-brand {
  height: var(--hero-height);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 0 1 auto; /* size to content — never stretch across the row */
  min-width: 0;
}

#hero .hero-logo {
  height: 72%; /* share of --hero-height; the slogan gets the rest */
  width: auto; /* width follows the SVG's aspect ratio → box hugs the artwork */
  max-width: 100%;
  object-fit: contain;
  padding-top: 0.7vw;
}

#hero .hero-slogan {
  flex: 0 0 auto;
  font-size: clamp(0.39rem, 2.2vw, 1.2rem);
  white-space: nowrap;
  text-align: center;
  line-height: 2;
}

#hero .hero-mascot {
  /* Same variable as .hero-brand → always exactly as tall
     as the logo + slogan stack */
  height: var(--hero-height);
  width: auto;
  object-fit: contain;
  object-position: left top; /* character hugs the left of its own box */
}

@media (max-width: 420px) {
  #hero .hero-slogan {
    white-space: normal; /* let the slogan wrap on very small phones */
  }
}

.parallax {
  background-image: url("@/assets/app-assets/teacher/teacher-stats-img.jpg");
}

#subscribe-btn {
  border: 1px solid #000000 !important;
}

#stats .v-parallax__image-container > img {
  transform: none !important;
  width: 100% !important;
  left: 0 !important;
}

#welcome-heading {
  /* -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: black; */
  text-shadow: -1px -1px 0 black, -1px 1px 0 black, 1px -1px 0 black,
    1px 1px 0 black;
}

#features-and-video #video-embed {
  width: 100%;
  height: 100%;
  margin: 0 auto;
}

#features-and-video #video-embed div {
  position: relative;
  padding-top: 25px;
  padding-bottom: 67.5%;
  height: 0;
}

#features-and-video #video-embed iframe {
  box-sizing: border-box;
  background: url(@/assets/app-assets/global/computer.jpg) center center
    no-repeat;
  background-size: contain;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.iframe-padding-huge iframe {
  padding: 3% 12.1% 24% 12.1%;
}

.iframe-padding-large iframe {
  padding: 3% 12.4% 24.2% 12.4%;
}

.iframe-padding-small iframe {
  padding: 3.1% 11.9% 24% 11.9%;
}

.iframe-padding-mobile iframe {
  padding: 3.2% 10.4% 25% 10.4%;
}
</style>
